import React from 'react';
import Link from 'gatsby-link';
import Content from '../components/layout/Content';
import Hero from '../components/layout/Hero';
import AFlogo from '../components/img/af-iverted-logo.svg';
import indy from '../components/img/indy-avatar.svg';

const index = ({ transition }) => (
  <div style={transition && transition.style}>
    <Content header>
      <Hero>
        <div className="hero">
          <h1 className="hero__heading">Jakten på den oslipade diamanten</h1>
          <h2 className="hero__heading">
            “Fantastiskt, enkelt och lättförståeligt, en tankeväckare”
          </h2>
          <div className="hero__subheading">Anonym användare november 2018</div>
          <h2 className="hero__heading">
            “Bra koncept och det blir roligare när man ska skriva annonser”
          </h2>
          <div className="hero__subheading">Anonym användare juli 2018</div>
          <p>
            Tusentals användare övade på att upptäcka arbetsmarknadens
            vanligaste floskler mellan juni och december 2018.
          </p>
          <p>
            Nu tar vi konceptet vidare och utvecklar ett verktyg för att
            prioritera vilka mjuka kompetenser som är viktigast när man
            rekryterar.
          </p>
          <p>
            Vill du delta i utvecklingsarbetet?
            <br />
            <a
              className="hero__contact-link"
              href="mailto:team-sokkandidater@arbetsformedlingen.se"
              target="_top"
            >
              Hör av dig till oss!
            </a>
          </p>
        </div>
      </Hero>
      <div className="logo-bar">
        <img src={AFlogo} alt={'Arbetsförmedlingen'} />
      </div>
    </Content>
  </div>
);

export default index;



// WEBPACK FOOTER //
// ./src/pages/index.js